import React, { useState } from 'react'
import { IconButton } from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip'
import ErrorIcon from '@material-ui/icons/Error'
import CancelarPenalizacionCamion from '../../camionesPenalizados/containers/CancelarPenalizacionCamion'

function CamionPenalizadoEnPlaya (props) {
  const { penalizado, patente } = props
  const [show, setShow] = useState(false)

  return (
    <div>
      {penalizado && <div style={{ display: 'flex', flexDirection: 'row' }}>
        <Tooltip title={'Camión penalizado'}>
          <IconButton onClick={() => setShow(!show)}>
            <ErrorIcon fontSize='default' color='error' />
          </IconButton>
        </Tooltip>

        <CancelarPenalizacionCamion patente={patente} />
      </div>
      }
    </div>
  )
}

export default CamionPenalizadoEnPlaya
